// Свой трекер лендингов: заход на лендинг и клик в Telegram/WhatsApp/Instagram.
// Пишет в cerus POST /api/t (backend/src/routes/track.ts) — для «Пульса» в
// админке. Подключается одним импортом в index.tsx и сам ловит переходы:
// клики по <a href> и вызовы window.open, поэтому CTA в ветках-зеркалах
// трогать не нужно. Работает только на *.lovestoria.org.
//
// Адрес абсолютный: у зеркал (pr, kz, co, …) REACT_APP_API_URL не настроен,
// а бэкенд живёт только на lovestoria.org.

const ENDPOINT = 'https://lovestoria.org/api/t';
const HOST_RE = /(^|\.)lovestoria\.org$/;
// Визит считаем только на самом лендинге: «/», «/ru», «/kk/» и т.п.
const LANDING_PATH_RE = /^\/([a-z]{2})?\/?$/;

type Target = 'telegram' | 'whatsapp' | 'instagram';

function targetOf(url: string): Target | null {
  const u = url.toLowerCase();
  if (/^tg:|\/\/(www\.)?(t\.me|telegram\.me)\//.test(u)) return 'telegram';
  if (/^whatsapp:|\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//.test(u)) return 'whatsapp';
  if (/\/\/(www\.)?(instagram\.com|ig\.me)\//.test(u)) return 'instagram';
  return null;
}

function session(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function setSession(key: string, value: string) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* приватный режим — живём без sessionStorage */
  }
}

function sid(): string {
  let id = session('ls_sid');
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    setSession('ls_sid', id);
  }
  return id;
}

// utm берём с первого захода вкладки: дальше по сайту они теряются из URL.
function utm() {
  const saved = session('ls_utm');
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch {
      /* битое значение — пересоберём */
    }
  }
  const q = new URLSearchParams(window.location.search);
  const value = {
    utmSource: q.get('utm_source') || '',
    utmCampaign: q.get('utm_campaign') || '',
    utmContent: q.get('utm_content') || '',
    fbclid: q.has('fbclid'),
  };
  setSession('ls_utm', JSON.stringify(value));
  return value;
}

function send(payload: Record<string, unknown>) {
  const body = JSON.stringify({
    host: window.location.hostname,
    path: window.location.pathname,
    sid: sid(),
    ...utm(),
    ...payload,
  });
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) return;
  } catch {
    /* упадём в fetch */
  }
  fetch(ENDPOINT, { method: 'POST', body, keepalive: true, mode: 'no-cors' }).catch(() => {});
}

// Один клик может прийти дважды: onClick → window.open и сам <a>.
let lastCta = { url: '', at: 0 };
function trackCta(url: string) {
  const target = targetOf(url);
  if (!target) return;
  const now = Date.now();
  if (lastCta.url === url && now - lastCta.at < 1500) return;
  lastCta = { url, at: now };
  send({ event: 'cta', target, targetUrl: url.slice(0, 300) });
}

export function initLandingTrack() {
  if (typeof window === 'undefined' || !HOST_RE.test(window.location.hostname)) return;

  utm();
  if (LANDING_PATH_RE.test(window.location.pathname) && !session('ls_visit')) {
    setSession('ls_visit', '1');
    send({ event: 'visit' });
  }

  document.addEventListener(
    'click',
    (e) => {
      const a = (e.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
      if (a) trackCta(a.href);
    },
    true
  );

  const open = window.open;
  window.open = function (url?: string | URL, ...rest: any[]) {
    if (url) trackCta(String(url));
    return open.call(window, url as any, ...rest);
  } as typeof window.open;
}
